interface YouTubeEmbedProps {
  videoId: string;
  fullWidth?: boolean;
  autoplay?: boolean;
}

export default function YouTubeEmbed({
  videoId,
  fullWidth = false,
  autoplay = false,
}: YouTubeEmbedProps) {
  return (
    <div
      className={`relative aspect-video ${fullWidth ? 'aspect-video w-full' : 'w-full aspect-video sm:w-[400px] sm:h-[225px]'}`}
    >
      <iframe
        className="absolute top-0 left-0 w-full h-full"
        src={`https://www.youtube.com/embed/${videoId}${autoplay ? '?autoplay=1' : ''}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
}
